import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import logo from '../../../img/nekrodruk-logo-dark.png';
import { openCookieSettings } from '../../../utils/analytics';
import { useAuth } from '../../../context/AuthContext';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const { isLoggedIn, isOwner } = useAuth();

    return (
        <footer className='footer'>
            <div className='footer_inner'>
                <div className='footer_brand'>
                    <Link to='/' aria-label='Nekrodruk – strona główna'>
                        <img className='footer_logo' src={logo} alt='Nekrodruk' />
                    </Link>
                    <p className='footer_tagline'>
                        Nekrologi, klepsydry, szarfy i tabliczki z jednego formularza – program dla zakładów pogrzebowych.
                    </p>
                </div>

                <nav className='footer_column' aria-label='Program'>
                    <h2 className='footer_heading'>Program</h2>
                    {/* Zalogowanym nie proponujemy zakładania konta ani logowania */}
                    {isLoggedIn ? (
                        <>
                            <Link to='/personForm'>Generowanie materiałów</Link>
                            <Link to='/sash'>Szarfy</Link>
                            <Link to={isOwner ? '/account' : '/accountemployee'}>Moje konto</Link>
                        </>
                    ) : (
                        <>
                            <Link to='/demo'>Demo bez logowania</Link>
                            <Link to='/register'>Załóż konto</Link>
                            <Link to='/login'>Zaloguj się</Link>
                        </>
                    )}
                </nav>

                <nav className='footer_column' aria-label='Poradniki'>
                    <h2 className='footer_heading'>Poradniki</h2>
                    <Link to='/poradniki'>Wszystkie poradniki</Link>
                    <Link to='/co-to-nekrolog'>Co to jest nekrolog?</Link>
                    <Link to='/klepsydra-wzor'>Klepsydra – wzór</Link>
                    <Link to='/napisy-na-szarfy'>Napisy na szarfy</Link>
                    <Link to='/drukowanie-szarf-pogrzebowych'>Drukowanie szarf</Link>
                    <Link to='/jak-zrobic-tabliczke-nagrobna'>Tabliczki nagrobne</Link>
                    <Link to='/marketing-zakladu-pogrzebowego'>Marketing zakładu</Link>
                    <Link to='/jakie-kwiaty-na-cmentarz'>Kwiaty na cmentarz</Link>
                    <Link to='/sprzedaz-zniczy-wszystkich-swietych'>Sprzedaż zniczy</Link>
                </nav>

                <nav className='footer_column' aria-label='Informacje'>
                    <h2 className='footer_heading'>Informacje</h2>
                    <a href='/Polityka_prywatnosci_nekrodruk.pdf' target='_blank' rel='noopener noreferrer'>Polityka prywatności</a>
                    <a href='/Regulamin_nekrodruk.pdf' target='_blank' rel='noopener noreferrer'>Regulamin</a>
                    <button type='button' className='footer_linkButton' onClick={openCookieSettings}>
                        Ustawienia cookies
                    </button>
                </nav>

                <div className='footer_column'>
                    <h2 className='footer_heading'>Kontakt</h2>
                    <a href='mailto:nekrodruk@gmail.com' className='footer_iconLink'>
                        <EmailOutlinedIcon fontSize='small' aria-hidden='true' />
                        nekrodruk@gmail.com
                    </a>
                    <a
                        href='https://www.facebook.com/profile.php?id=61579782703147'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='footer_iconLink'
                    >
                        <FacebookIcon fontSize='small' aria-hidden='true' />
                        Facebook
                    </a>
                </div>
            </div>

            <div className='footer_bottom'>
                <p>© {currentYear} Nekrodruk.pl. Wszelkie prawa zastrzeżone.</p>
            </div>
        </footer>
    );
}
